<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/coach' }">
        <app-i18n code="entities.coach.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.coach.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.coach.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-coach-view-toolbar v-if="record"></app-coach-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-relation-to-many
          :label="fields.teams.label"
          :permission="fields.teams.readPermission"
          :url="fields.teams.viewUrl"
          :value="presenter(record, 'teams')"
        ></app-view-item-relation-to-many>

        <app-view-item-text :label="fields.firstName.label" :value="presenter(record, 'name')"></app-view-item-text>

        <app-view-item-text :label="fields.lastName.label" :value="presenter(record, 'lastName')"></app-view-item-text>

        <app-view-item-text :label="fields.gender.label" :value="presenter(record, 'gender')"></app-view-item-text>

        <app-view-item-text :label="fields.country.label" :value="presenter(record, 'country')"></app-view-item-text>

        <app-view-item-text :label="fields.type.label" :value="presenter(record, 'type')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CoachViewToolbar from '@modules/coach/components/coach-view-toolbar.vue';
import { CoachModel } from '@modules/coach/coach-model';

export default {
  name: 'app-coach-view-page',

  props: ['id'],

  components: {
    [CoachViewToolbar.name]: CoachViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'coach/view/record',
      loading: 'coach/view/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    fields() {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).fields();
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'coach/view/doFind',
    }),

    presenter(record, fieldName) {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },
  },
};
</script>
